export default __webpack_public_path__ + "static/media/Successful purchase-cuate.96f7c06d.png";